module.exports = new __parcel__URL__("minus.50f2fc12.svg").toString();